
import { granjaApi } from "../../api";
import { useItemspagoStore } from "../../store";
import Swal from "sweetalert2";






export const startListadoItemsCompra = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/itemscompra/todos', { params });
        useItemspagoStore.setState({ totalItemsPago: data.total });
        return data.data;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startSavingItemCompra = async(item) => {
    try {
        await granjaApi.post('/itemscompra/new', item);
        Swal.fire('Exitoso', 'Item Creado', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 




export const startDeleteItemsCompra = async(items) => {
    try {
        await granjaApi.post(`/itemscompra/eliminar`, items);
        Swal.fire('Exitoso', 'Items de compra eliminado', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
}